// RSSRenderer.js
import React, { useEffect, useState } from 'react';

const RSSRenderer = ({ feedUrl, maxItems = 5, durationPerItem = 5 }) => {
  const [items, setItems] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchRSS = async () => {
      try {
        const proxy = 'https://cors-anywhere.herokuapp.com/';
        const response = await fetch(proxy + feedUrl);
        const text = await response.text();
        const parser = new DOMParser();
        const xml = parser.parseFromString(text, 'text/xml');

        const itemElements = xml.querySelectorAll('item');
        const parsedItems = Array.from(itemElements).slice(0, maxItems).map(item => ({
          title: item.querySelector('title')?.textContent || '',
          description: item.querySelector('description')?.textContent || '',
        }));

        setItems(parsedItems);
      } catch (err) {
        console.error('RSS load error:', err);
      }
    };

    fetchRSS();
  }, [feedUrl, maxItems]);

  useEffect(() => {
    if (items.length === 0) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % items.length);
    }, durationPerItem * 1000);
    return () => clearInterval(interval);
  }, [items, durationPerItem]);

  if (items.length === 0) return <div style={{ color: 'white' }}>Loading RSS...</div>;

  return (
    <div style={{
      width: '100%',
      height: '100%',
      color: 'white',
      backgroundColor: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.3em',
      padding: '10px',
      textAlign: 'center',
    }}>
      {items[currentIndex].title}
    </div>
  );
};

export default RSSRenderer;
